import { FormGroup } from '@angular/forms';
import { FilterItemDto } from '../models/request/filter-item.dto';
import { Operators } from 'src/core/models/request/operator.enum';
export class FilterHelper {
  static getFilterValues(formGroup: FormGroup): FilterItemDto[] {
    let filters: FilterItemDto[] = [];
    const filterGroups = formGroup.value;
    for (const key of Object.keys(filterGroups)) {
      if (filterGroups.hasOwnProperty(key)) {
        const innerObj = filterGroups[key];
        if (Array.isArray(innerObj.value)) {
          if (innerObj.value.length > 0) {
            var arr = [];
            innerObj.value.forEach(element => {
              if (element.id) {
                arr.push(element.id);
              }
            });
            if (arr.length > 0) {
              innerObj.value = arr;
            }
            filters.push(innerObj);
          }
        } else {
          if (innerObj.value) {
            filters.push(innerObj);
          } else if (typeof innerObj == 'boolean') {
            filters.push({
              field: key,
              operator: 0,
              value: innerObj,
            });
          }
        }
      }
    }
    return filters;
  }

  public static getFilterValueFromArrayObject(
    values: any[],
    operator: number,
    field: string,
    property: string
  ): FilterItemDto[] {
    const ids: any[] = [];

    if (values && values.length > 0) {
      for (let i = 0; i < values.length; i++) {
        const id = values[i][property];
        ids.push(id);
      }
    }

    if (ids.length > 0) {
      return [
        {
          operator: operator,
          value: ids,
          field: field,
        },
      ];
    } else {
      return [];
    }
  }
}
